var _style, _path, _g, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "us-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f5f5f5 } \n\t\t.s1 { fill: #ff4b55 } \n\t\t.s2 { fill: #41479b } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0 0h20v20h-20z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0 0h20v1.5h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0 6.2h20v1.5h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0 3.1h20v1.5h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0 9.2h20v1.6h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0 15.4h20v1.5h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0 18.5h20v1.5h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0 12.3h20v1.5h-20z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m0 0h10.8v10.8h-10.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1.4 0.8l0.1 0.3h0.2c0.1 0 0.1 0 0 0l-0.2 0.2 0.1 0.2c0 0.1 0 0.1 0 0.1l-0.3-0.2-0.2 0.2c0 0 0 0 0-0.1l0.1-0.2-0.3-0.2c0 0 0 0 0.1 0h0.2l0.1-0.3c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1.4 2.9l0.1 0.2h0.2c0.1 0 0.1 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0 0 0.1 0 0l-0.3-0.1-0.2 0.1c0 0.1 0 0 0 0l0.1-0.2-0.3-0.2c0 0 0-0.1 0.1-0.1h0.2l0.1-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1.4 5.2l0.1 0.2h0.2c0.1 0 0.1 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0 0 0.1 0 0l-0.3-0.1-0.2 0.1c0 0.1 0 0 0 0l0.1-0.2-0.3-0.2c0 0 0-0.1 0.1-0.1h0.2l0.1-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1.4 7.3l0.1 0.2 0.2 0.1c0.1 0 0.1 0 0 0l-0.2 0.2 0.1 0.2c0 0.1 0 0.1 0 0.1l-0.3-0.2-0.2 0.2c0 0 0 0 0-0.1l0.1-0.2-0.3-0.2c0 0 0 0 0.1 0l0.2-0.1 0.1-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1.4 9.2l0.1 0.3h0.2c0.1 0 0.1 0 0 0l-0.2 0.2 0.1 0.2c0 0.1 0 0.1 0 0.1l-0.3-0.2-0.2 0.2c0 0 0 0 0-0.1l0.1-0.2-0.3-0.2c0 0 0 0 0.1 0h0.2l0.1-0.3c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m2.4 1.8l0.1 0.2h0.2c0.1 0 0.1 0.1 0.1 0.1l-0.3 0.2 0.1 0.2c0 0 0 0.1 0 0.1l-0.2-0.2-0.3 0.2c0 0 0-0.1 0-0.1l0.1-0.2-0.2-0.2c-0.1 0-0.1-0.1 0-0.1h0.2l0.1-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m2.4 4.1l0.1 0.2h0.2c0.1 0 0.1 0.1 0.1 0.1l-0.3 0.2 0.1 0.2c0 0 0 0.1 0 0.1l-0.2-0.2-0.3 0.2c0 0 0-0.1 0-0.1l0.1-0.2-0.2-0.2c-0.1 0-0.1-0.1 0-0.1h0.2l0.1-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m2.4 6.3l0.1 0.2h0.2c0.1 0 0.1 0.1 0.1 0.1l-0.3 0.2 0.1 0.2c0 0 0 0.1 0 0l-0.2-0.1-0.3 0.1c0 0.1 0 0 0 0l0.1-0.2-0.2-0.2c-0.1 0-0.1-0.1 0-0.1h0.2l0.1-0.2c0-0.1 0.1-0.1 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m2.4 8.2l0.1 0.3h0.2c0.1 0 0.1 0 0.1 0.1l-0.3 0.1 0.1 0.3c0 0 0 0 0 0l-0.2-0.2-0.3 0.2c0 0 0 0 0 0l0.1-0.3-0.2-0.1c-0.1-0.1-0.1-0.1 0-0.1h0.2l0.1-0.3c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m3.4 0.8l0.1 0.3h0.2c0.1 0 0.1 0 0.1 0l-0.3 0.2 0.1 0.2c0 0.1 0 0.1 0 0.1l-0.2-0.2-0.3 0.2c0 0 0 0 0-0.1l0.1-0.2-0.2-0.2c-0.1 0-0.1 0 0 0h0.2l0.1-0.3c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m3.4 2.9l0.1 0.2h0.2c0.1 0 0.1 0.1 0.1 0.1l-0.3 0.2 0.1 0.2c0 0 0 0.1 0 0l-0.2-0.1-0.3 0.1c0 0.1 0 0 0 0l0.1-0.2-0.2-0.2c-0.1 0-0.1-0.1 0-0.1h0.2l0.1-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m3.4 5.2l0.1 0.2h0.2c0.1 0 0.1 0.1 0.1 0.1l-0.3 0.2 0.1 0.2c0 0 0 0.1 0 0l-0.2-0.1-0.3 0.1c0 0.1 0 0 0 0l0.1-0.2-0.2-0.2c-0.1 0-0.1-0.1 0-0.1h0.2l0.1-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m3.4 7.3l0.1 0.2 0.2 0.1c0.1 0 0.1 0 0.1 0l-0.3 0.2 0.1 0.2c0 0.1 0 0.1 0 0.1l-0.2-0.2-0.3 0.2c0 0 0 0 0-0.1l0.1-0.2-0.2-0.2c-0.1 0-0.1 0 0 0l0.2-0.1 0.1-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m3.4 9.2l0.1 0.3h0.2c0.1 0 0.1 0 0.1 0l-0.3 0.2 0.1 0.2c0 0.1 0 0.1 0 0.1l-0.2-0.2-0.3 0.2c0 0 0 0 0-0.1l0.1-0.2-0.2-0.2c-0.1 0-0.1 0 0 0h0.2l0.1-0.3c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m4.4 1.8l0.1 0.2h0.2c0.1 0 0.1 0.1 0.1 0.1l-0.2 0.2v0.2c0 0 0 0.1 0 0.1l-0.2-0.2-0.2 0.2c-0.1 0-0.1-0.1-0.1-0.1l0.1-0.2-0.2-0.2c-0.1 0 0-0.1 0-0.1h0.3v-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m4.4 4.1l0.1 0.2h0.2c0.1 0 0.1 0.1 0.1 0.1l-0.2 0.2v0.2c0 0 0 0.1 0 0.1l-0.2-0.2-0.2 0.2c-0.1 0-0.1-0.1-0.1-0.1l0.1-0.2-0.2-0.2c-0.1 0 0-0.1 0-0.1h0.3v-0.2c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m4.4 6.3l0.1 0.2h0.2c0.1 0 0.1 0.1 0.1 0.1l-0.2 0.2v0.2c0 0 0 0.1 0 0l-0.2-0.1-0.2 0.1c-0.1 0.1-0.1 0-0.1 0l0.1-0.2-0.2-0.2c-0.1 0 0-0.1 0-0.1h0.3v-0.2c0-0.1 0.1-0.1 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m4.4 8.2l0.1 0.3h0.2c0.1 0 0.1 0 0.1 0.1l-0.2 0.1v0.3c0 0 0 0 0 0l-0.2-0.2-0.2 0.2c-0.1 0-0.1 0-0.1 0l0.1-0.3-0.2-0.1c-0.1-0.1 0-0.1 0-0.1h0.3v-0.3c0 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m5.4 0.8l0.1 0.3h0.3c0 0 0 0 0 0l-0.2 0.2v0.2c0.1 0.1 0 0.1 0 0.1l-0.2-0.2-0.2 0.2c-0.1 0-0.1 0-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0 0 0 0h0.3v-0.3c0.1 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m5.4 2.9l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2v0.2c0.1 0 0 0.1 0 0l-0.2-0.1-0.2 0.1c-0.1 0.1-0.1 0-0.1 0l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3v-0.2c0.1 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m5.4 5.2l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2v0.2c0.1 0 0 0.1 0 0l-0.2-0.1-0.2 0.1c-0.1 0.1-0.1 0-0.1 0l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3v-0.2c0.1 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m5.4 7.3l0.1 0.2 0.3 0.1c0 0 0 0 0 0l-0.2 0.2v0.2c0.1 0.1 0 0.1 0 0.1l-0.2-0.2-0.2 0.2c-0.1 0-0.1 0-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0 0 0 0l0.3-0.1v-0.2c0.1 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m5.4 9.2l0.1 0.3h0.3c0 0 0 0 0 0l-0.2 0.2v0.2c0.1 0.1 0 0.1 0 0.1l-0.2-0.2-0.2 0.2c-0.1 0-0.1 0-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0 0 0 0h0.3v-0.3c0.1 0 0.1 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m6.4 1.8l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0-0.1 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c-0.1 0-0.1-0.1-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m6.4 4.1l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0-0.1 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c-0.1 0-0.1-0.1-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m6.4 6.3l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0-0.1 0.1-0.1 0l-0.2-0.1-0.2 0.1c-0.1 0.1-0.1 0-0.1 0l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0-0.1 0-0.1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m6.4 8.2l0.1 0.3h0.3c0 0 0 0 0 0.1l-0.2 0.1 0.1 0.3c0 0-0.1 0-0.1 0l-0.2-0.2-0.2 0.2c-0.1 0-0.1 0-0.1 0l0.1-0.3-0.2-0.1c0-0.1 0-0.1 0-0.1h0.3l0.1-0.3c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m7.4 0.8l0.1 0.3h0.3c0 0 0 0 0 0l-0.2 0.2 0.1 0.2c0 0.1-0.1 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c0 0-0.1 0-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0 0 0 0h0.3l0.1-0.3c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m7.4 2.9l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0-0.1 0.1-0.1 0l-0.2-0.1-0.2 0.1c0 0.1-0.1 0-0.1 0l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m7.4 5.2l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0-0.1 0.1-0.1 0l-0.2-0.1-0.2 0.1c0 0.1-0.1 0-0.1 0l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m7.4 7.3l0.1 0.2 0.3 0.1c0 0 0 0 0 0l-0.2 0.2 0.1 0.2c0 0.1-0.1 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c0 0-0.1 0-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0 0 0 0l0.3-0.1 0.1-0.2c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m7.4 9.2l0.1 0.3h0.3c0 0 0 0 0 0l-0.2 0.2 0.1 0.2c0 0.1-0.1 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c0 0-0.1 0-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0 0 0 0h0.3l0.1-0.3c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m8.4 1.8l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0-0.1 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c0 0-0.1-0.1-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m8.4 4.1l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0-0.1 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c0 0-0.1-0.1-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m8.4 6.3l0.1 0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0-0.1 0.1-0.1 0l-0.2-0.1-0.2 0.1c0 0.1-0.1 0-0.1 0l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0-0.1 0-0.1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m8.4 8.2l0.1 0.3h0.3c0 0 0 0 0 0.1l-0.2 0.1 0.1 0.3c0 0-0.1 0-0.1 0l-0.2-0.2-0.2 0.2c0 0-0.1 0-0.1 0l0.1-0.3-0.2-0.1c0-0.1 0-0.1 0-0.1h0.3l0.1-0.3c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m9.5 0.8v0.3h0.3c0 0 0 0 0 0l-0.2 0.2 0.1 0.2c0 0.1 0 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c0 0-0.1 0-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0 0 0 0h0.3l0.1-0.3c0 0 0 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m9.5 2.9v0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0 0 0.1-0.1 0l-0.2-0.1-0.2 0.1c0 0.1-0.1 0-0.1 0l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0 0 0 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m9.5 5.2v0.2h0.3c0 0 0 0.1 0 0.1l-0.2 0.2 0.1 0.2c0 0 0 0.1-0.1 0l-0.2-0.1-0.2 0.1c0 0.1-0.1 0-0.1 0l0.1-0.2-0.2-0.2c0 0 0-0.1 0-0.1h0.3l0.1-0.2c0 0 0 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m9.5 7.3v0.2l0.3 0.1c0 0 0 0 0 0l-0.2 0.2 0.1 0.2c0 0.1 0 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c0 0-0.1 0-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0 0 0 0l0.3-0.1 0.1-0.2c0 0 0 0 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m9.5 9.2v0.3h0.3c0 0 0 0 0 0l-0.2 0.2 0.1 0.2c0 0.1 0 0.1-0.1 0.1l-0.2-0.2-0.2 0.2c0 0-0.1 0-0.1-0.1l0.1-0.2-0.2-0.2c0 0 0 0 0 0h0.3l0.1-0.3c0 0 0 0 0.1 0z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.a5ee3945654b0ae596e175f4aa484f92.svg";
export { ForwardRef as ReactComponent };